











































import { Component, Prop, Vue } from 'vue-property-decorator';
import { deviceApi } from '../device.api';

@Component
export default class DeviceUnassignBtn extends Vue {
  @Prop()
  public device: any;

  public isModalActive = false;
  public isUnassigning = false;

  public get isBtnVisible(): boolean {
    return this.device.uuid && !this.device.deletedAt;
  }

  public async unassign(): Promise<void> {
    this.isModalActive = false;
    this.isUnassigning = true;
    try {
      await deviceApi.unassign(this.device.id);
      this.$buefy.snackbar.open({
        message: 'Téléphone désassocié',
        queue: false,
      });
      this.device.uuid = null;
      this.$emit('unassigned');
      // this.getDevices();
    } catch (_) {
      this.$buefy.snackbar.open({
        type: 'is-danger',
        message: 'Une erreur est survenue',
        queue: false,
      });

      this.$emit('error');
    }

    this.isUnassigning = false;
  }

  public cancel(): void {
    this.isModalActive = false;
  }
}
